<template>
  <div class="tw-my-6 md:tw-my-12">
    <Inpatient />
    <div class="tw-flex tw-justify-center tw-mt-4 md:tw-my-10">
      <AdditionalBenefits />
    </div>
  </div>
</template>

<script>
import AdditionalBenefits from '@/components/rfq/health/AdditionalBenefits';
import Inpatient from '@/components/rfq/health/components/Inpatient';

export default {
  name: 'InpatientPlan',
  components: { Inpatient, AdditionalBenefits },
};
</script>
